import styled from "styled-components";
import { Icon } from "antd";

export const AlignItemsCenter = styled.div`
  align-items:center! important;
`;

export const IconAlert = styled(Icon)`
  font-size:18px!important;
`;

export const AccountCardContainer = styled.div`
 
  strong{
    color: #002737;
  }
  margin:30px 0;
  @media only screen and (max-width:767px){
    margin:20px 0;
  }
  &:last-of-type{
    margin-bottom:50px;
    @media only screen and (max-width:767px){
      margin-bottom:40px;
    }
  }
  &:nth-child(3){
    margin-top:50px;
    @media only screen and (max-width:767px){
        margin-top:40px;
    }
  }

 .open {
    display: block;
  }
  
  .close {
    display: none;
  }
  
  .ant-card-body>div:first-of-type {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  
  .ant-card-body div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .card {
    border: none;
    box-shadow: none;
    background-color: #f2f2f2!important;
    margin-bottom: ${props => props.BottomMargin}
    margin-top: ${props => props.TopMargin}
  }
  
  .card .tool-tip {
    position: relative;
    display: inline-block;
    outline: none;
    padding: 0px 2px;
  }
  
  .ant-card-body {
    padding: 15px 35px;
    border-left: 6px solid #e37222;
  }
  
  .ant-card-body p,
  .ant-card-body a {
    margin-bottom: 0;
    font-family: HelveticaNeue;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: normal;
  }
  
  .ant-row::before,
  .ant-row::after {
    display: inline;
  }
  
  .ant-card-body p {
    line-height: 1.5;
    color: #505050;
    @media only screen and (max-width:767px){
      font-size:14px;
    }
  }
  
  .ant-card-body a {
    color: #006778;
    font-family: HelveticaNeue-Bold;
    text-decoration: underline;
  }
  
  .anticon-warning {
    color: #e37222;
    display: inline-block;
    font-size: 18px;
    padding-right: 10px;
    cursor: auto;
  }
  
  .anticon-close {
    color: #000000;
    display: inline-block;
    font-size: 18px;
  }
  
  p.desktop {
    display: inline-block;
    vertical-align: middle;
  }

  p.pendingAlertContent {
    display: inline-block;
    vertical-align: middle;
    @media only screen and (max-width: 767px) {
      line-height: 20px;
      font-size: 14px;
    }
  }
  
  p.mobile {
    display: none;
  }
  
  .ant-card-body {
    padding: 20px 30px;
  }
  
  @media only screen and (max-width: 767px) {
    .ant-card-body {
      padding: 10px 10px;
      border-top: 6px solid #e37222;
      border-left: none;
    }
    .card {
      margin-top: 20px;
    }
    p.mobile {
      line-height: 20px;
      font-size: 14px;
      display: inline-block;
      vertical-align: middle;
    }
    .ant-card-body div>img {
      width: 15px;
      height: 15px;
    }
    .ant-card-body div:first-child {
     align-items: center;
    }
    .ant-card-body div:first-child> div {
      align-items: flex-start;
    }
    .anticon-warning {
      padding-top: 4px;
      font-size: 13px;
    }
    p.desktop {
      display: none;
    }
    
  }
  `;
